import { ColumnDef } from "@tanstack/react-table";
import { Case } from "@/views/cases/data/schema";
import { NameBadge } from "@/components/badge-gen";
import { Badge } from "@/components/ui/badge";
import i18n from '@/i18n';
import { IconChecklist } from "@tabler/icons-react";
import { formatDistanceToNow } from "date-fns";
import { ar } from "date-fns/locale";

export const userCaseColumns = (): ColumnDef<Case>[] => {
  const baseColumns: ColumnDef<Case>[] = [
    {
      accessorKey: "case_details",
      header: () => null,
      cell: ({ row }) => {
        const caseItem = row.original;
        const types = i18n.t('case_type_name', { returnObjects: true }) as string[];
        const caseTypeName = caseItem.type && caseItem.type ? caseItem.type.name : types[0];

        const date = caseItem.updated_at;

        return (
          <div className="p-2 border-b border-border last:border-b-0 hover:bg-muted/50 transition-colors">
            <div className="grid grid-cols-2 gap-x-2">
              <div className="flex flex-col items-start justify-start">
                <div className="flex items-center gap-2 mb-0.5">
                  <IconChecklist size={18} className="text-primary flex-shrink-0" />
                  <span className="font-semibold text-base leading-tight truncate" title={caseItem.name}>{caseItem.name}</span>
                </div>
                {caseItem.type && <NameBadge name={caseTypeName} className="text-xs mb-0.5" />}
                {caseItem.client && (
                  <div className="text-xs text-muted-foreground truncate" title={caseItem.client.name}>
                    {i18n.t("client")}: {caseItem.client.name}
                  </div>
                )}
              </div>

              <div className="flex flex-col items-end justify-start">
                <Badge
                  variant="outline"
                  className="font-mono text-xs bg-gradient-to-r from-violet-50 to-indigo-50 border-indigo-200 dark:from-violet-900/30 dark:to-indigo-900/30 dark:border-indigo-700/50"
                >
                  {caseItem.id}
                </Badge>
                <span className="text-xs text-muted-foreground mt-1 text-left">
                  {i18n.t("last_update")}: {<>
                    <div className='w-fit text-nowrap'>
                      {date.toLocaleDateString('en-GB')}
                    </div>
                    <span className="w-fit text-nowrap text-xs text-muted-foreground">({formatDistanceToNow(date, { addSuffix: true, locale: ar })})</span>
                  </>}
                </span>
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  return baseColumns;
};
